export default "__VITE_ASSET__7c0bfcbf__"